import React from "react";
import { Button, Modal } from "react-bootstrap";

import classNames from "classnames";

import { ProductModalProps } from "@LeagueManagement/Order/types/order";

const ReinstateProductModal = ({
    show,
    product,
    handleClose,
    handleSubmit,
}: ProductModalProps): React.JSX.Element => (
    <Modal show={show} onHide={handleClose} centered>
        <Modal.Header>
            <Modal.Title className={classNames("text-center")}>
                Are you sure you want to reinstate this registration?
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <h6>Registration Info:</h6>
            <dl className={classNames("inline")}>
                <dt>League:</dt>
                <dd>{product.description}</dd>
                {product.meta.teamName && (
                    <>
                        <dt>Team:</dt>
                        <dd>{product.meta.teamName}</dd>
                    </>
                )}
            </dl>
            <p className={classNames("mb-0")}>
                Reinstating the registration will:
            </p>
            <ul>
                <li>
                    Restore <b>this</b> league registration.
                </li>
                <li>Take one open spot in this league (if applicable)</li>
                <li>Restore the order if the order was cancelled</li>
            </ul>
        </Modal.Body>
        <Modal.Footer>
            <Button variant="primary" onClick={handleClose}>
                No
            </Button>
            <Button
                variant="success"
                onClick={() => {
                    handleSubmit("reinstateProduct", handleClose, {
                        productId: product.id,
                        teamId: product.meta.teamId!,
                    });
                }}
            >
                Yes
            </Button>
        </Modal.Footer>
    </Modal>
);

export default ReinstateProductModal;
